<div layout layout-vertical>
  <div layout layout-horizontal layout-align-items-center>
    @switch (group().kind) {
      @case (AccessKind.Role) {
        <ng-container
          *ngTemplateOutlet="
            header;
            context: {
              icon: 'people',
              header: group().name,
              subheader:
                'app.candidate.share_dialog.team_members.who_has_access_list.role.subheader'
                | translate: { count: group().count },
            }
          "
        ></ng-container>
      }
      @case (AccessKind.Job) {
        <ng-container
          *ngTemplateOutlet="
            header;
            context: {
              icon: 'sidemenu-offers',
              header:
                'app.candidate.share_dialog.team_members.who_has_access_list.offer.header'
                | translate: { offerTitle: group().name },
              subheader:
                'app.candidate.share_dialog.team_members.who_has_access_list.offer.subheader'
                | translate: { count: group().count },
            }
          "
        ></ng-container>
      }
      @case (AccessKind.TalentPool) {
        <ng-container
          *ngTemplateOutlet="
            header;
            context: {
              icon: 'talent-pools',
              header:
                'app.candidate.share_dialog.team_members.who_has_access_list.talent_pool.header'
                | translate: { talentPoolName: group().name },
              subheader:
                'app.candidate.share_dialog.team_members.who_has_access_list.talent_pool.subheader'
                | translate: { count: group().count },
            }
          "
        ></ng-container>
      }
    }
  </div>
  @if (isExpanded) {
    <div layout layout-vertical layout-full-width margin-bottom-medium>
      @for (user of group().admins; track user.adminId) {
        <div class="user" layout layout-horizontal layout-align-items-center>
          <rt-avatar
            [type]="user.hasAvatar ? 'image' : 'initials'"
            [initials]="user.initials"
            [size]="'small'"
            [shape]="'oval'"
            [imageSrc]="user.photoThumbUrl"
            context="admin"
          >
          </rt-avatar>
          <div class="username" [class.with-border]="!$last" layout layout-vertical>
            <div>{{ user.firstName }} {{ user.lastName }}</div>
          </div>
        </div>
      }
    </div>
  }
  @if (!isLast()) {
    <rt-divider />
  }
</div>
<ng-template #header let-header="header" let-icon="icon" let-subheader="subheader">
  <div class="header clickable" padding-tb-small (click)="toggle()">
    <rt-avatar
      type="icon"
      size="small"
      shape="oval"
      customIconBackgroundColor="colorAvatarSteelLighter"
      customIconColor="colorIconLowDefault"
      [iconName]="$any(icon)"
      context="other"
    >
    </rt-avatar>
    <div class="info" layout layout-vertical>
      <div class="name">{{ header }}</div>
      <div class="subheader">{{ subheader }}</div>
    </div>
    <div class="toggler">
      <rt-icon [name]="isExpanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'"></rt-icon>
    </div>
  </div>
</ng-template>
